import { type App, inject } from 'vue'

export type BenchmarkAggregated = {
    end: (message?: string) => number
}

export type BenchAggregatedFunction = (prefix: string) => BenchmarkAggregated

const key = 'app.plugin.bench.aggregated'
export function installBenchAggregated(app: App): BenchAggregatedFunction {
    const times: Record<string, number[]> = {}

    const bench = (prefix: string): BenchmarkAggregated => {
        const startedAt = new Date()
        const start = performance.now()
        let isEnded = false
        let total: number

        // eslint-disable-next-line no-console
        console.log(`${startedAt.toISOString()} > START ${prefix}`)

        if (!(prefix in times)) {
            times[prefix] = []
        }

        return {
            end: (message) => {
                if (isEnded) {
                    return total
                }

                isEnded = true

                const now = new Date()
                const end = performance.now()
                total = end - start

                times[prefix]!.push(total)

                const entries = Object.entries(times[prefix]!)
                const cnt = entries.length
                const sum = entries.reduce((acc, next) => {
                    return acc + next[1]
                }, 0)
                const avg = sum / cnt

                // eslint-disable-next-line no-console
                console.log(
                    `${now.toISOString()} < END   ${prefix}: bench: ${total.toFixed(3)}ms, total: ${sum.toFixed(3)}ms, ${cnt} times, ${avg.toFixed(3)}ms avg - ${message}`
                )

                return total
            },
        }
    }

    app.provide(key, bench)

    return bench
}

export function useBenchAggregated(): BenchAggregatedFunction {
    return inject(key) as BenchAggregatedFunction
}
